import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AuthLogin from "../AuthLogin";
import AuthRegister from "../AuthRegister";
import AuthVerify from "../AuthVerify";
import AuthPasswordRecovery from "../AuthPasswordRecovery";
import PublicHome from "../PublicHome";

import { useTheme } from "@mui/material/styles";

const AdminAuth = () => {
  const theme = useTheme();

  // Styles JS utilisant le thème
  const styles = {
    root: {
      background: "#f3f3f3",
      minHeight: "100vh",
    },
    header: {
      display: theme.breakpoints?.down("md") ? "none" : "block",
      border: "3px solid green",
    },
    footer: {
      border: "3px solid blue",
    },
  };

  return (
    <div style={styles.root}>
      <Routes>
        <Route path="/login" element={<AuthLogin />} />
        <Route path="/register" element={<AuthRegister />} />
        <Route path="/recover-password" element={<AuthPasswordRecovery />} />
        <Route path="/verify" element={<AuthVerify />} />
        <Route path="/" element={<PublicHome />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
};

export default AdminAuth;
